import React, { Component } from "react";

// Libraries
import { motion } from "framer-motion";

// Styles
import "./StartScreen.scss";

// Components

// Images
// import CodeBerryBackground from 'static/img/codeberry-background.jpg'

import { ButtonSound } from "../../utility/sounds"
import { storage } from "services/config/storage";

class StartScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.gameDetails = storage.get.gameDetails();
  }

  componentDidMount() {
    localStorage.removeItem("is_reloaded");
    document.querySelector("body").style.overflow = "hidden";
    localStorage.getItem("wrongMoves") && localStorage.removeItem("wrongMoves");
    localStorage.getItem("moves1") && localStorage.removeItem("moves1");
    localStorage.getItem("moves2") && localStorage.removeItem("moves2");
    localStorage.getItem("moves3") && localStorage.removeItem("moves3");
    localStorage.getItem("undos") && localStorage.removeItem("undos");
    localStorage.getItem("pressedPlayButtonWithEmptyLoops") &&
      localStorage.removeItem("pressedPlayButtonWithEmptyLoops");
    setTimeout(() => {
      this.props.history.replace("/welcomecontinued");
    }, 3000);
  }

  componentWillUnmount() {
    document.querySelector("body").style.overflow = "auto";
  }

  initFullScreenMode() {
    let elem = document.querySelector(".App");
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      /* Firefox */
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Chrome, Safari & Opera */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE/Edge */
      elem.msRequestFullscreen();
    }
  }

  render() {
    return (
      <div className="start-page">
        <div className="start-page__main-container">
          {/* Title */}
          {
            this.gameDetails?.mediaUrl ?
            <div
              className="start-page__title--image-container"
            >
              <motion.div 
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 1
                }}
              >
                <img src={this.gameDetails.mediaUrl} />
              </motion.div>
            </div> :
            <div
              className="start-page__title--container"
            >
              <motion.p
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: -20, opacity: 1 }}
                transition={{
                  duration: 1
                }}
                className="start-page__title--text"
              >
                Bot
              </motion.p>
              <motion.p
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: -20, opacity: 1 }}
                transition={{
                  duration: 1
                }}
                className="start-page__title--text active"
              >
                Berry
              </motion.p>
            </div>
          }
          {
              this.gameDetails?.organizationName &&
              <motion.p
                initial={{ y: 100, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{
                  duration: 1
                }}
                className="start-page__title--org-text active"
              >
                Powered by <span style={{ fontWeight: '700' }}>{this.gameDetails.organizationName}</span>
              </motion.p>
            }

          <div className="start-page__bottom-container">
            {/* <div className="level-duration">
            <div className="start-page__bottom-container--stats-container">
              <div className="stat">
                <p className="stat__title">
                  Levels
                </p>
                <p className="stat__value">
                  {levelsMap.length}
                </p>
              </div>
              <div className="stat__divider">

              </div>
              <div className="stat">
                <p className="stat__title">
                  Time
                </p>
                <p className="stat__value">
                  {Math.floor(GAME_TIME / 60)}<span className="stat__value--small">min</span>
                </p>
              </div>
              </div>
            </div> */}
          </div>
        </div>
      </div>
    );
  }
}
export default StartScreen;
